"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = _interopRequireDefault(require("lemon-db/dist/options/text.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var options = _text["default"];
exports.options = options;
var allowedSizes = Object.values(options.sizes);
allowedSizes.push('tiny');
var sizeMap = {
  xLarge: 'title2',
  large: 'large',
  medium: 'medium',
  small: 'small',
  tiny: 'tiny'
};

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UIText = _ref.UIText;

  var Text = /*#__PURE__*/function (_React$Component) {
    _inherits(Text, _React$Component);

    var _super = _createSuper(Text);

    function Text() {
      _classCallCheck(this, Text);

      return _super.apply(this, arguments);
    }

    _createClass(Text, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            size = _this$props.size,
            kind = _this$props.kind,
            children = _this$props.children,
            link = _this$props.link,
            inline = _this$props.inline,
            align = _this$props.align,
            color = _this$props.color,
            theme = _this$props.theme,
            noWrap = _this$props.noWrap;
        var wrappedText = children;

        if (typeof children === 'string') {
          wrappedText = children.split('\n').map(function (text, index) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: index
            }, text, /*#__PURE__*/_react["default"].createElement("br", null));
          });
        }

        if (link) {
          wrappedText = /*#__PURE__*/_react["default"].createElement("a", {
            href: link,
            target: "__blank",
            rel: "noopener noreferrer"
          }, wrappedText);
        }

        var bold = kind.indexOf('bold') > -1;
        var italic = kind.indexOf('italic') > -1;
        var underlined = kind.indexOf('underlined') > -1;
        var style = {};

        if (color) {
          style.color = color;
        }

        return /*#__PURE__*/_react["default"].createElement(UIText, {
          theme: theme,
          style: style,
          size: sizeMap[size] || 'regular',
          inline: inline,
          align: align,
          italic: italic,
          underlined: underlined,
          weight: bold ? 'bold' : 'normal',
          nowrap: noWrap
        }, wrappedText);
      }
    }]);

    return Text;
  }(_react["default"].Component);

  var displayName = identifier;
  Text.displayName = displayName;
  Text.themeShape = {
    text: _propTypes["default"].string.isRequired,
    title1: _propTypes["default"].string.isRequired,
    title2: _propTypes["default"].string.isRequired,
    large: _propTypes["default"].string.isRequired,
    regular: _propTypes["default"].string.isRequired,
    small: _propTypes["default"].string.isRequired,
    tiny: _propTypes["default"].string.isRequired,
    left: _propTypes["default"].string.isRequired,
    center: _propTypes["default"].string.isRequired,
    right: _propTypes["default"].string.isRequired,
    justified: _propTypes["default"].string.isRequired,
    bold: _propTypes["default"].string.isRequired,
    light: _propTypes["default"].string.isRequired,
    thin: _propTypes["default"].string.isRequired,
    normal: _propTypes["default"].string.isRequired,
    underlined: _propTypes["default"].string.isRequired,
    italic: _propTypes["default"].string.isRequired
  };
  Text.propTypes = {
    children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
    size: _propTypes["default"].oneOf(allowedSizes),
    align: _propTypes["default"].oneOf(Object.values(options.align)),
    kind: _propTypes["default"].array,
    link: _propTypes["default"].string,
    inline: _propTypes["default"].bool,
    noWrap: _propTypes["default"].bool,
    color: _propTypes["default"].string,
    theme: UIText.propTypes.theme
  };
  Text.defaultProps = {
    size: 'medium',
    kind: [],
    link: '',
    inline: false
  };
  return Text;
};

var _default = factory;
exports["default"] = _default;